module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Storage Ottoman_Sand.9b980762.png";